import { Action } from '@ngrx/store';

import { AuthenticationState } from '../shared-state.interface';
import { AuthenticationActionTypes } from './authentication.actions';

export const emptyAuthenticationState: AuthenticationState = {
    isAuthenticated: false
};

export const initialAuthenticationState: AuthenticationState = emptyAuthenticationState;

export function authenticationReducer(state = initialAuthenticationState, action: Action): AuthenticationState {
    switch (action.type) {
        case AuthenticationActionTypes.Login:
            return { ...state, isAuthenticated: true };

        case AuthenticationActionTypes.Logout: {
            return { ...state, isAuthenticated: false };
        }

        default:
            return state;
    }
}
